import { Pipe, PipeTransform, inject } from '@angular/core';
import { AssetImagesProviderService } from '../providers/asset-images-provider.service';
import { AssetImage } from '../enums/asset-image';

@Pipe({
  name: 'assetImageUrl',
  standalone: true,
})
export class AssetImageUrlPipe implements PipeTransform {
  private readonly provider = inject(AssetImagesProviderService);

  public transform(image: AssetImage): string {
    return this.provider.url(image);
  }
}
